import { styled } from '@mui/material';

export const SpeechTopicsRoot = styled('div')({
  width: '100%',
  margin: 0,
  padding: 0,
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
});

